import { render } from "./CheckboxForm.vue?vue&type=template&id=da2911fe"
import script from "./CheckboxForm.vue?vue&type=script&lang=js"
export * from "./CheckboxForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__